// REGISTER screen (display name + email + password). Calls POST /api/auth/register.
// Shares its visual furniture with login.ts via ui/authVisuals.
import {
  authBackdropHTML,
  authField,
  theoStageHTML,
  ICON_EMAIL,
  ICON_LOCK,
  ICON_USER,
} from '../ui/authVisuals';

export const registerHTML = /* html */ `
<div id="screenRegister" class="authscreen hidden">
  ${authBackdropHTML}
  <div class="auth-top">
    <button class="icon-btn back" id="registerBackBtn" type="button" aria-label="Back">
      <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="currentColor"><path d="M11.7 4.3a1.2 1.2 0 0 1 0 1.7L7.7 10l4 4a1.2 1.2 0 1 1-1.7 1.7l-4.8-4.8a1.2 1.2 0 0 1 0-1.7L10 4.3a1.2 1.2 0 0 1 1.7 0Z"/></svg>
    </button>
  </div>

  ${theoStageHTML('Come, let us begin together.')}

  <div class="hero">
    <div class="title">Join the game</div>
    <div class="tagline">Create an account to save your bank, medals &amp; streaks.</div>
  </div>

  <form class="auth-form auth-card" id="registerForm" novalidate>
    ${authField({
      id: 'regName',
      label: 'Display name',
      icon: ICON_USER,
      inputHTML:
        '<input type="text" id="regName" name="displayName" autocomplete="nickname" required minlength="5" maxlength="20" placeholder="5–20 characters" />',
      extraHTML: '<span class="avail" id="regNameAvail" aria-live="polite"></span>',
      afterHTML: '<div class="avail-hint" id="regNameHint"></div>',
    })}
    ${authField({
      id: 'regEmail',
      label: 'Email',
      icon: ICON_EMAIL,
      inputHTML:
        '<input type="email" id="regEmail" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required />',
      extraHTML: '<span class="avail" id="regEmailAvail" aria-live="polite"></span>',
      afterHTML: '<div class="avail-hint" id="regEmailHint"></div>',
    })}
    ${authField({
      id: 'regPassword',
      label: 'Password',
      icon: ICON_LOCK,
      inputHTML:
        '<input type="password" id="regPassword" name="password" autocomplete="new-password" required minlength="8" placeholder="At least 8 characters" />',
      pwToggleId: 'regPwToggle',
    })}
    <div class="auth-msg" id="registerMsg"></div>
    <button class="btn" type="submit" id="registerSubmit">Create Account</button>
    <div class="auth-alt">Already have an account? <button type="button" id="registerToLogin">Sign in</button></div>
    <div class="auth-alt"><button type="button" id="registerAsGuest">Continue as guest</button></div>
    <div class="legal-note">By creating an account you agree to our <a href="terms.html" target="_blank" rel="noopener">Terms of Service</a> and <a href="privacy.html" target="_blank" rel="noopener">Privacy Policy</a>.</div>
  </form>
</div>`;
